import { render, staticRenderFns } from "./SwitchInput.vue?vue&type=template&id=81780476&scoped=true"
import script from "./SwitchInput.vue?vue&type=script&lang=js"
export * from "./SwitchInput.vue?vue&type=script&lang=js"
import style0 from "./SwitchInput.vue?vue&type=style&index=0&id=81780476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81780476",
  null
  
)

export default component.exports